module.exports = __webpack_public_path__ + "static/media/promo_button.31acf1a2.png";